'use strict';
function _typeof(e) {
    return (_typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
        return typeof e;
    } : function (e) {
        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
    })(e);
}
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.addBackGuide = void 0;
var addBackGuide = function (o) {
    if ('object' !== ('undefined' == typeof window ? 'undefined' : _typeof(window)) || !o || document.referrer.includes('ifeng.com') || window.top !== window.self)
        return !1;
    var t = location.href;
    window.addEventListener('load', function () {
        var e = new Date().getTime();
        window.addEventListener('popstate', function () {
            200 < new Date().getTime() - e && location.href.includes(o) && location.reload();
        }, !1);
        try {
            window.history.replaceState(null, '', o), window.history.pushState('', '', t);
        } catch (e) {
            console.error(e);
        }
    });
};
exports.addBackGuide = addBackGuide;